import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core/react/i18n';

// eslint-disable-next-line @change/sibling-module-imports
import { useIsMobile } from 'src/app/pages/starterDashboardV2/hooks/useIsMobile';
import { BadgeScore } from 'src/app/shared/components/badges';
import { InfoTooltip } from 'src/app/shared/components/tooltips';

import { usePetitionStrengthScore } from './hooks/usePetitionStrengthScore';

export const PetitionStrengthScore: React.FC = () => {
	const { data, actions } = usePetitionStrengthScore();
	const isMobile = useIsMobile();

	return (
		<div className="flex w-full flex-col items-center gap-6 p-6 md:items-start md:justify-start md:gap-4 md:p-0">
			<div className="flex items-center gap-1 md:justify-start">
				<Text
					as="h3"
					variant="heading"
					size="x-small"
					className="m-0"
					id="petition-strength-title"
					data-qa="petition-strength-title"
				>
					<Translate value="corgi.petition.starter_dashboard.petition_overview.strength_score.title" />
				</Text>
				<InfoTooltip data-qa="petition-strength-tooltip" aria-describedby="petition-strength-title">
					<TranslateHtml value="corgi.petition.starter_dashboard.petition_overview.strength_score.tip" />
				</InfoTooltip>
			</div>
			<div className="flex flex-col items-center gap-2 md:items-start">
				<BadgeScore score={data.score} />
				{data.score < 10 && (
					<Button
						variant="tertiary"
						size={isMobile ? 'small' : 'x-small'}
						as="a"
						className="self-center px-2 md:self-start md:p-0"
						data-qa="improve-strength-rating-link"
						href={data.petitionStrengthUrl}
						onClick={actions.improveStrengthLinkClick}
					>
						<Translate value="corgi.petition.starter_dashboard.petition_overview.strength_score.improve_link" />
					</Button>
				)}
			</div>
		</div>
	);
};
